export const LIST_STORES = 'LIST_STORES';
export const STORE_SUCCESS = 'STORE_SUCCESS';
export const STORE_ERROR = 'STORE_ERROR';
